import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@BUP/hooks';
import { isModeBup } from 'services/BraveUp';
import { RBAC } from '@BUP/components';

const Navigation = () => {
	const { user } = useAuth();

	return (
		<nav>
			<div className="nav-element-wrapper">
				<NavLink
					exact
					className="nav-link"
					to="/"
				>
					INICIO
      	</NavLink>
			</div>
			<div
				className="nav-element-wrapper"
			>
				<NavLink
					className="nav-link"
					to="/resources"
				>
					RECURSOS
				</NavLink>
			</div>
			<div className="nav-element-wrapper">
				<RBAC
					name="navWebinars"
				>
				<NavLink
				
				className="nav-link "
				to="/webinars"
			>
				SEMINARIOS WEB
			  </NavLink>
					
				</RBAC>
				
			</div>
			{
				isModeBup(user) ?
					(
						<div
							className="nav-element-wrapper"
							style={{ marginBottom: 25 }}
						>
							<NavLink
								className="nav-link"
								to="/modebup"
							>
								MODO BUP!
					</NavLink>
							<RBAC
								name="navModeBupSendLink"
							>
								<NavLink
									className="sub-nav-link"
									to="/modebup/send"
									style={{ marginTop: 14 }}
								>
									Enviar MODO BUP!
								</NavLink>
							</RBAC>
							<NavLink
								className="sub-nav-link"
								to="/modebup/inbox"
							>
								Bandeja de entrada
					</NavLink>
							<RBAC
								name="navModeBupArchivedLink"
							>
								<NavLink
									className="sub-nav-link"
									to="/modebup/archived"
								>
									Casos Archivados
						</NavLink>
							</RBAC>
						</div>
					) : null
			}
			<div className="nav-element-wrapper">
				<NavLink
					className="nav-link disabled"
					to="/data"
				>
					DATA!
      	</NavLink>
			</div>
		</nav>
	)
}

export default Navigation;